import { Graphics, Vec2, Vec3, Color } from 'cc';

type DrawOptions = {
    lineWidth?: number;
    color?: Color;
};

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    interface Graphics {
        drawLine(p0: Vec2 | Vec3, p1: Vec2 | Vec3, options?: DrawOptions): void;
        drawCircle(p0: Vec2 | Vec3, radius: number, options?: DrawOptions & { fill?: boolean }): void;
        drawBezier(p0: Vec2 | Vec3, p1: Vec2 | Vec3, p2: Vec2 | Vec3, p3: Vec2 | Vec3, options?: DrawOptions): void;
        drawPoint(position: Vec2 | Vec3, length: number, options?: DrawOptions): void;
    }
}

Graphics.prototype.drawLine = function drawLine(this: Graphics, p0: Vec2 | Vec3, p1: Vec2 | Vec3, options?: DrawOptions): void {
    if (options?.lineWidth) {
        this.lineWidth = options.lineWidth;
    }
    if (options?.color) {
        this.strokeColor = options.color;
    }
    this.moveTo(p0.x, p0.y);
    this.lineTo(p1.x, p1.y);
    this.stroke();
};

Graphics.prototype.drawCircle = function drawCircle(this: Graphics, p0: Vec2 | Vec3, radius: number, options?: DrawOptions & { fill?: boolean }): void {
    if (options?.lineWidth) {
        this.lineWidth = options.lineWidth;
    }
    if (options?.color) {
        this.strokeColor = options.color;
        this.fillColor = options.color;
    }
    this.circle(p0.x, p0.y, radius);
    if (options.fill) {
        this.fill();
    } else {
        this.stroke();
    }
};

Graphics.prototype.drawBezier = function drawBezier(
    this: Graphics,
    p0: Vec2 | Vec3,
    p1: Vec2 | Vec3,
    p2: Vec2 | Vec3,
    p3: Vec2 | Vec3,
    options?: DrawOptions,
): void {
    if (options?.lineWidth) {
        this.lineWidth = options.lineWidth;
    }
    if (options?.color) {
        this.strokeColor = options.color;
    }
    this.moveTo(p0.x, p0.y);
    this.bezierCurveTo(p1.x, p1.y, p2.x, p2.y, p3.x, p3.y);
    this.stroke();
};

Graphics.prototype.drawPoint = function drawPoint(this: Graphics, position: Vec2 | Vec3, length: number, options?: DrawOptions): void {
    if (options?.lineWidth) {
        this.lineWidth = options.lineWidth;
    }
    if (options?.color) {
        this.fillColor = options.color;
    }
    this.rect(position.x - length / 2, position.y - length / 2, length, length);
    this.fill();
};
